module.exports = __webpack_public_path__ + "img/Invasion-BRCA_10X_DCIS.d9131dc1.png";